import { ErrorBoundary } from "react-error-boundary";
import Layout from "../../components/Layout";
import { CircularProgress } from "@mui/material";
import { fallbackRender } from "components/FallbackRender";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

const Home = () => {
  return (
    <Layout>
      <Suspense fallback={<CircularProgress />}>
        <ErrorBoundary fallbackRender={fallbackRender}>
          <Outlet />
        </ErrorBoundary>
      </Suspense>
    </Layout>
  );
};

export default Home;
